__turbopack_context__.v({
  "card": "TournamentGrid-module__1AF4bW__card",
  "cardTint": "TournamentGrid-module__1AF4bW__cardTint",
  "detailTitle": "TournamentGrid-module__1AF4bW__detailTitle",
  "details": "TournamentGrid-module__1AF4bW__details",
  "filterLabel": "TournamentGrid-module__1AF4bW__filterLabel",
  "filterReset": "TournamentGrid-module__1AF4bW__filterReset",
  "filterSelect": "TournamentGrid-module__1AF4bW__filterSelect",
  "filters": "TournamentGrid-module__1AF4bW__filters",
  "heading": "TournamentGrid-module__1AF4bW__heading",
  "layout": "TournamentGrid-module__1AF4bW__layout",
  "metaBadge": "TournamentGrid-module__1AF4bW__metaBadge",
  "photo": "TournamentGrid-module__1AF4bW__photo",
  "podiumTeam": "TournamentGrid-module__1AF4bW__podiumTeam",
  "statRow": "TournamentGrid-module__1AF4bW__statRow",
  "statValue": "TournamentGrid-module__1AF4bW__statValue",
  "titleAge": "TournamentGrid-module__1AF4bW__titleAge",
  "visual": "TournamentGrid-module__1AF4bW__visual",
});
